import React, { Component } from "react";
import OutboundConfigContextProvider from "../outboundAmzl/context/OutboundConfigContext";
import OutboundPredicate from "./OutboundPredicate";
import CapabilityContextProvider from "../overview/context/CapabilityContext";

class OutboundOverviewRoot extends Component {
  render() {
    return (
      <CapabilityContextProvider>
        <OutboundConfigContextProvider>
          <OutboundPredicate />
        </OutboundConfigContextProvider>
      </CapabilityContextProvider>
    );
  }
}

export default OutboundOverviewRoot;



// WEBPACK FOOTER //
// ./src/components/outboundOverview/OutboundOverviewRoot.js